import { render, staticRenderFns } from "./RetailerSettings.vue?vue&type=template&id=092d670b&"
import script from "./RetailerSettings.vue?vue&type=script&lang=js&"
export * from "./RetailerSettings.vue?vue&type=script&lang=js&"
import style0 from "./RetailerSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports